/* ══════════════════════════════════════════════════════════════════
   LUCERNA MIAMI — the engine.

   Every page is the same shell. The body's data-page attribute says
   which sections exist; a renderer that finds no mount point simply
   returns, so one file drives the whole house.
   ══════════════════════════════════════════════════════════════════ */
(function () {
"use strict";

var $  = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var RM = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
var lerp = function (a, b, t) { return a + (b - a) * t; };
var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
var esc = function (s) {
  return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

var CFG = window.LUX_CONFIG || {};
var ASSET = function (f) {
  if (/^(https?:)?\/\//.test(f)) return f;          /* already absolute */
  return (CFG.asset || function (x) { return "assets/" + x; })(f);
};
/* Every cut is photographed in the house's own studio, one stone face-up
   on seamless black. The frame is served from the photo CDN; the local
   file of the same name is the understudy if the CDN ever goes quiet, and
   STONE_FALL wires that swap onto the element itself. */
var STONE = function (slug) {
  var m = CFG.cuts || {};
  return m[slug] || ASSET(slug + ".webp");
};
/* A tile draws a stone at about 70px and the hero at 240. Serving one
   896px file to both wastes most of what it downloads, so the local
   frames ship in two sizes and the browser is told which it needs.
   The house's own CDN frames come in one size only — hosting those
   here is what would let them do the same. */
/* Four real widths, each declared at the width it actually is. The
   previous pair said 256w for a 192px file and then jumped straight to
   the 896px master, so a phone at three device pixels per CSS pixel
   needed 304px, found nothing between, and pulled the master down for
   every tile in the tray — about a megabyte to draw thirty-nine stones
   a hundred pixels wide. A browser can only choose well from honest
   numbers. */
var STONE_SET = function (slug, tile) {
  if ((CFG.cuts || {})[slug]) return "";          // one size, from the CDN
  return ' srcset="' + ASSET(slug + "-xs.webp") + " 96w, " +
         ASSET(slug + "-sm.webp") + " 192w, " +
         ASSET(slug + "-tn.webp") + " 320w, " +
         ASSET(slug + "-md.webp") + " 512w, " +
         ASSET(slug + ".webp") + ' 896w" sizes="' +
         (tile ? "(max-width:620px) 26vw, 140px" : "(max-width:940px) 56vw, 420px") + '"';
};
var STONE_FALL = function (slug, size) {
  /* The understudy stands in at the size the slot actually draws. */
  var local = ASSET(slug + (size || "") + ".webp");
  /* The understudy is a smaller file, so it also takes a class and is set
     a little smaller rather than enlarged past its own resolution. */
  return ' data-fallback="' + local + '" onerror="if(this.src!==this.dataset.fallback)' +
         '{this.src=this.dataset.fallback;this.classList.add(\'understudy\')}"';
};

var PAGE = CFG.page || function (k) { return k === "home" ? "index.html" : k + ".html"; };
var API = CFG.api || "";
/* On Shopify the configurator can check out without any Worker: every
   setting is a real product with a real price, and the page adds the
   chosen variant to the cart. CFG.cart carries {prefix, root}. */
var CART = CFG.cart || null;
var CHECKOUT = CART ? "cart" : (API && CFG.checkout !== "quote" ? "worker" : "");
var TIKTOK = CFG.tiktok || "https://www.tiktok.com/@lucernadiamonds";
var EMAIL = CFG.email || "info@lucernamiami.com";

/* The English title and description are written at build time, where
   they can be composed for a search result and an answer engine rather
   than reused from the page's opening line. They are captured here so
   the renderer can put them back verbatim, and only writes its own when
   the house is answering in Spanish. */
var SSR_TITLE = document.title;
var SSR_DESC = (function () {
  var m = document.querySelector('meta[name="description"]');
  return m ? m.getAttribute("content") : "";
})();
function head(title, desc) {
  if (lang === "en" && SSR_DESC) { title = SSR_TITLE; desc = SSR_DESC; }
  document.title = title;
  var m = document.querySelector('meta[name="description"]');
  if (m) m.setAttribute("content", desc);
}

var HERE = document.body.getAttribute("data-page") || "home";
/* On Shopify the attribute carries the page handle, not the room name.
   LUX_PAGES maps room -> handle, so invert it when they differ. */
(function () {
  var map = window.LUX_PAGES || {};
  if (map[HERE]) return;                       /* already a room name */
  for (var k in map) {
    if (String(map[k]).replace(/\.html$/, "") === HERE) { HERE = k; return; }
  }
  if (HERE === "terms" || HERE === "privacy" || HERE === "shipping") HERE = "legal";
})();
/* Worn is gone: it showed photographs of pieces the house has not
   made yet. The Journal takes its place, because an account of real
   commissions is the version of that page that can be true. */
var NAV_MAIN = ["book", "diamond", "custom", "journal", "vault", "house"];
var NAV_MORE = ["careers", "contact"];

/* language: ?lang= wins, then whatever this visitor chose last time,
   then English. The door opens in English and the house answers in
   Spanish the moment anyone asks — once asked, it is remembered. */
var lang = "en";
try {
  var q = new URLSearchParams(location.search).get("lang");
  var saved = localStorage.getItem("lux-lang");
  if (q === "en" || q === "es") lang = q;
  else if (saved === "en" || saved === "es") lang = saved;
} catch (e) {}

var C = window.LUX_CONTENT, COLORS = window.LUX_COLORS,
    CUTS = window.LUX_CUTS || [], PIECES = window.LUX_PIECES,
    PRICES = window.LUX_PRICES;
/* The chart is the Worker's to decide. The copy bundled here is a
   fallback for the moment before the answer arrives, and for the day the
   Worker cannot be reached -- a visitor still sees a price rather than a
   blank configurator, and the Worker prices the order either way, so the
   two can never disagree at checkout. */
function adoptPrices(p) {
  if (!p || !p.table || !p.metals || !p.bands || !p.pieces) return false;
  PRICES = window.LUX_PRICES = p;
  return true;
}
function t() { return C[lang]; }
function P(k) { return PAGE(k) + (lang === "es" ? "?lang=es" : ""); }

/* split a heading into per-word masks so it rises line by line */
function words(html) {
  var tmp = document.createElement("div");
  tmp.innerHTML = String(html).replace(/<br\s*\/?>/gi, "\n");
  var out = "", wi = 0;
  Array.prototype.forEach.call(tmp.childNodes, function (node) {
    var em = node.nodeType === 1 && node.tagName === "EM";
    (node.textContent || "").split(/(\s+)/).forEach(function (w) {
      if (!w) return;
      if (/^\s+$/.test(w)) { out += w.indexOf("\n") > -1 ? "<br>" : " "; return; }
      out += '<span class="sp"><i style="transition-delay:' + (wi * 0.055).toFixed(3) + 's">' +
             (em ? "<em>" + esc(w) + "</em>" : esc(w)) + "</i></span>";
      wi++;
    });
  });
  return out;
}

/* ══════════════════════════════════════════════════════════════════
   THE MARK — a round brilliant crown at true proportion.
   55% table, eight kites, eight stars, sixteen upper girdle facets.
   ══════════════════════════════════════════════════════════════════ */
function mark(o) {
  o = o || {};
  var cx = 200, cy = 200, R = o.r || 168, w = o.w || 1,
      hair = o.hair == null ? 1 : o.hair,
      rt = R * 0.545, rk = R * 0.735, s = R / 100, d = [];
  var Pt = function (r, a) { a = a * Math.PI / 180; return [cx + r * Math.cos(a), cy + r * Math.sin(a)]; };
  var line = function (pts, sw, op) {
    d.push('<path d="M ' + pts.map(function (p) { return p[0].toFixed(1) + " " + p[1].toFixed(1); }).join(" L ") +
      (op && op.close ? " Z" : "") + '" stroke-width="' + (sw * s * w).toFixed(2) + '"' +
      (op && op.o != null ? ' opacity="' + op.o + '"' : "") + "/>");
  };
  d.push('<circle cx="200" cy="200" r="' + R.toFixed(1) + '" stroke-width="' + (2.6 * s * w).toFixed(2) + '"/>');
  var tv = []; for (var k = 0; k < 8; k++) tv.push(Pt(rt, -90 + k * 45));
  line(tv, 2.6, { close: true });
  for (var i = 0; i < 8; i++) {
    var a = -90 + i * 45, sh = a + 22.5;
    var t1 = Pt(rt, a), t2 = Pt(rt, a + 45), sk = Pt(rk, sh),
        g1 = Pt(R, a), g2 = Pt(R, a + 45), gs = Pt(R, sh);
    line([t1, sk, t2], 1.15, { o: .92 });
    if (hair) {
      line([sk, g1], .80, { o: .58 * hair });
      line([sk, g2], .80, { o: .58 * hair });
      line([sk, gs], .65, { o: .40 * hair });
    }
  }
  return d.join("");
}
function markSvg(attrs, o) {
  return '<svg viewBox="0 0 400 400" aria-hidden="true" ' + (attrs || "") +
    ' fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' +
    mark(o) + "</svg>";
}

/* ══════════════════════════════════════════════════════════════════
   THE TINTS
   Stones are rendered white once, then any of the ten colours is
   poured over them with one transfer curve:

       f(x) = x * ( c + (1-c) * x^4 * H )

   The linear term lays the body colour over the stone; the x^4 term
   hands the brightest speculars back to white, which is what keeps a
   fancy yellow reading as a diamond instead of a boiled sweet.
   ══════════════════════════════════════════════════════════════════ */
var TINT_H = 0.86, TINT_H_DEEP = 0.42;
function hx(h) {
  var c = [parseInt(h.substr(1, 2), 16) / 255,
           parseInt(h.substr(3, 2), 16) / 255,
           parseInt(h.substr(5, 2), 16) / 255];
  var m = Math.max(c[0], c[1], c[2]) || 1;   /* hue without loss of brightness */
  return [c[0] / m, c[1] / m, c[2] / m];
}
function curve(rgb, H) {
  var ch = "RGB", out = "", k, i, x, v;
  for (k = 0; k < 3; k++) {
    v = [];
    for (i = 0; i < 9; i++) { x = i / 8; v.push((x * (rgb[k] + (1 - rgb[k]) * Math.pow(x, 4) * H)).toFixed(4)); }
    out += '<feFunc' + ch[k] + ' type="table" tableValues="' + v.join(" ") + '"/>';
  }
  return out;
}
function mountTints() {
  if ($("#lux-tints")) return;
  var defs = COLORS.map(function (c) {
    var rgb = hx(c.hex);
    return '<filter id="tint-' + c.key + '" color-interpolation-filters="sRGB">' +
           "<feComponentTransfer>" + curve(rgb, TINT_H) + "</feComponentTransfer></filter>" +
           '<filter id="tint-' + c.key + '-deep" color-interpolation-filters="sRGB">' +
           "<feComponentTransfer>" + curve(rgb, TINT_H_DEEP) + "</feComponentTransfer></filter>";
  }).join("");
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("id", "lux-tints"); svg.setAttribute("aria-hidden", "true");
  svg.innerHTML = "<defs>" + defs + "</defs>";
  document.body.appendChild(svg);
}
function setSel(key) {
  var c = COLORS.filter(function (x) { return x.key === key; })[0] || COLORS[0];
  var rgb = [parseInt(c.hex.substr(1, 2), 16), parseInt(c.hex.substr(3, 2), 16), parseInt(c.hex.substr(5, 2), 16)];
  var r = document.documentElement.style;
  r.setProperty("--sel", c.hex);
  r.setProperty("--sel-r", rgb[0]); r.setProperty("--sel-g", rgb[1]); r.setProperty("--sel-b", rgb[2]);
}

/* ══════════════════════════════════════════════════════════════════
   REVEAL
   ══════════════════════════════════════════════════════════════════ */
var io = new IntersectionObserver(function (es) {
  es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("r-in"); io.unobserve(e.target); } });
}, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
function watch() { $$(".rev:not(.r-in)").forEach(function (n) { io.observe(n); }); }

var ioShot = new IntersectionObserver(function (es) {
  es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); ioShot.unobserve(e.target); } });
}, { threshold: .15 });

/* ══════════════════════════════════════════════════════════════════
   CHROME — veil, cursor, lamp, dust, nav, progress
   ══════════════════════════════════════════════════════════════════ */
function veil() {
  var v = $("#veil"); if (!v) return;
  var svg = $("#veilMark");
  if (svg) {
    svg.innerHTML = mark({ r: 150, w: 1.6, hair: .55 });
    $$("path,circle", svg).forEach(function (n, i) {
      var L = 520; try { L = n.getTotalLength() || 520; } catch (e) {}
      if (!isFinite(L) || !L) L = 520;
      n.style.setProperty("--L", L.toFixed(0));
      n.style.animationDelay = (i * 0.016).toFixed(3) + "s";
    });
  }
  function lift() {
    /* Unconditional, always, before anything else can go wrong. */
    document.body.classList.remove("locked");
    document.body.classList.add("ready");
    if (v.classList.contains("gone")) return;
    v.classList.add("gone");
    setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 1300);
    watch();
    $$("#hero .rev, #pagehead .rev").forEach(function (n) { n.classList.add("r-in"); });
  }
  /* The curtain is on a clock, and the clock is short.

     It used to wait for window.load before starting its exit, which
     means it waited for every image on the page — and the stones come
     from a CDN. One slow response and the visitor sat looking at a
     wordmark, unable to scroll, with no idea anything was wrong. A
     curtain is a piece of theatre and theatre is never allowed to hold
     the door shut.

     So: a fixed, short beat, measured from the moment the markup is
     ready, and nothing it waits on can fail. */
  document.body.classList.add("locked");
  setTimeout(lift, RM ? 120 : 1150);
  /* And if even that is somehow missed, the page comes back anyway. */
  setTimeout(function () { document.body.classList.remove("locked"); }, 2600);
}

function cursor() {
  if (!window.matchMedia("(hover:hover) and (pointer:fine)").matches || RM) return;
  document.body.classList.add("fine");
  var cur = $("#cur"), dot = $("#curDot"), lamp = $("#lamp");
  if (!cur) return;
  var mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my, lx = mx, ly = my;
  addEventListener("mousemove", function (e) {
    mx = e.clientX; my = e.clientY;
    dot.style.transform = "translate3d(" + mx + "px," + my + "px,0)";
    if (!document.body.classList.contains("lit")) document.body.classList.add("lit");
  }, { passive: true });
  (function loop() {
    cx = lerp(cx, mx, .17); cy = lerp(cy, my, .17);
    lx = lerp(lx, mx, .055); ly = lerp(ly, my, .055);
    cur.style.transform = "translate3d(" + cx + "px," + cy + "px,0)";
    if (lamp) lamp.style.transform = "translate3d(" + (lx - innerWidth / 2) + "px," + (ly - innerHeight * .4) + "px,0)";
    requestAnimationFrame(loop);
  })();
  var sel = "a,button,summary,input,select,textarea,.cut,.chip,.opt,.door,details";
  addEventListener("mouseover", function (e) {
    if (e.target.closest && e.target.closest(sel)) document.body.classList.add("grab");
  }, { passive: true });
  addEventListener("mouseout", function (e) {
    if (e.target.closest && e.target.closest(sel)) document.body.classList.remove("grab");
  }, { passive: true });
}

function dust() {
  var c = $("#dust"); if (!c || RM) return;
  var x = c.getContext("2d"), w, h, dpr = Math.min(devicePixelRatio || 1, 2), Pa = [];
  function size() {
    w = c.width = innerWidth * dpr; h = c.height = innerHeight * dpr;
    c.style.width = innerWidth + "px"; c.style.height = innerHeight + "px";
    var n = Math.min(64, Math.round(innerWidth / 24)); Pa = [];
    for (var i = 0; i < n; i++) Pa.push({
      x: Math.random() * w, y: Math.random() * h, r: (Math.random() * 1.5 + .35) * dpr,
      vy: -(Math.random() * .16 + .035) * dpr, vx: (Math.random() - .5) * .09 * dpr,
      a: Math.random() * .42 + .07, p: Math.random() * Math.PI * 2
    });
  }
  size(); addEventListener("resize", size, { passive: true });
  (function draw() {
    x.clearRect(0, 0, w, h);
    var cs = getComputedStyle(document.documentElement);
    var R = cs.getPropertyValue("--sel-r").trim() || "198",
        G = cs.getPropertyValue("--sel-g").trim() || "166",
        B = cs.getPropertyValue("--sel-b").trim() || "100";
    for (var i = 0; i < Pa.length; i++) {
      var p = Pa[i];
      p.y += p.vy; p.x += p.vx + Math.sin(p.p += 0.0045) * .12 * dpr;
      if (p.y < -12) { p.y = h + 12; p.x = Math.random() * w; }
      if (p.x < -12) p.x = w + 12; if (p.x > w + 12) p.x = -12;
      var tw = p.a * (.58 + .42 * Math.sin(p.p * 2.4));
      x.beginPath(); x.arc(p.x, p.y, p.r, 0, 6.283);
      x.fillStyle = "rgba(" + R + "," + G + "," + B + "," + tw.toFixed(3) + ")"; x.fill();
    }
    requestAnimationFrame(draw);
  })();
}

function chrome() {
  var nav = $("#nav"), prog = $("#prog"), top = $("#top"), last = 0, ticking = false;
  function frame() {
    var y = scrollY || 0;
    if (nav) {
      nav.classList.toggle("stuck", y > 20);
      nav.classList.toggle("hide", y > 460 && y > last && !($("#drawer") || {}).classList?.contains("open"));
    }
    last = y;
    var max = document.documentElement.scrollHeight - innerHeight;
    if (prog) prog.style.transform = "scaleX(" + (max > 0 ? clamp(y / max, 0, 1) : 0) + ")";
    if (top) top.classList.toggle("on", y > 900);
    if (!RM) {
      /* The parallax moves the stage, not the stones. A transform on
         an ancestor of a stone opens a stacking context, and the stone
         screens itself onto the page through that ancestor — so moving
         the wrapper would put the frame's black ground back on screen
         as a box. The rings and the stones ride along together. */
      /* The rings drift; the stones do not. Anything transformed above
         a stone becomes a stacking context, and the stone screens onto
         the page through it — so the parallax is given to the orbits,
         which are the stone's siblings and not its parents. */
      var rings = $(".stage"), off = (y * .055).toFixed(1);
      if (rings && y < innerHeight * 1.3)
        $$(".stage .ring,.stage .halo").forEach(function (el) {
          el.style.marginTop = off + "px";
        });
    }
    ticking = false;
  }
  addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  frame();
  if (top) top.addEventListener("click", function () { scrollTo({ top: 0, behavior: RM ? "auto" : "smooth" }); });

  var bg = $("#burger"), dr = $("#drawer");
  if (bg && dr) {
    bg.addEventListener("click", function () {
      var open = dr.classList.toggle("open");
      bg.setAttribute("aria-expanded", String(open));
      document.body.classList.toggle("locked", open);
      if (open) $$("a,.nav-live", dr).forEach(function (a, i) {
        a.style.animation = "none"; void a.offsetWidth;
        a.style.animation = "dIn .6s var(--t-out) " + (i * 0.055 + 0.05) + "s forwards";
      });
    });
    dr.addEventListener("click", function (e) {
      if (e.target.closest("a")) { dr.classList.remove("open"); bg.setAttribute("aria-expanded", "false");
        document.body.classList.remove("locked"); }
    });
  }
  /* in-page anchors clear the fixed nav */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute("href"); if (id === "#" || id.length < 2) return;
    var tgt = document.querySelector(id); if (!tgt) return;
    e.preventDefault();
    scrollTo({ top: tgt.getBoundingClientRect().top + scrollY - 78, behavior: RM ? "auto" : "smooth" });
  });
}

/* ══════════════════════════════════════════════════════════════════
   SECTIONS
   Each renderer returns the moment it finds no mount point, so one
   file drives every page in the house.
   ══════════════════════════════════════════════════════════════════ */
function set(id, html) { var n = $("#" + id); if (n) n.innerHTML = html; return n; }
function txt(id, s) { var n = $("#" + id); if (n) n.textContent = s; return n; }

function navLink(k) {
  var n = t().nav;
  return '<a href="' + P(k) + '"' + (k === HERE ? ' aria-current="page"' : "") + ">" + esc(n[k]) + "</a>";
}
function renderNav() {
  var mark32 = markSvg('width="32" height="32"', { r: 168, w: 4.0, hair: 0 });
  $$(".brand").forEach(function (b) {
    var s = $("svg", b); if (s) s.outerHTML = mark32;
  });
  set("nav-links", NAV_MAIN.map(navLink).join(""));
  var dr = $("#drawer");
  if (dr) {
    dr.innerHTML = ["home"].concat(NAV_MAIN, NAV_MORE).map(navLink).join("") +
      '<a class="nav-live" href="' + TIKTOK + '" target="_blank" rel="noopener">' +
      '<i class="dot"></i><span>' + (lang === "es" ? "En vivo" : "Live") + "</span></a>";
  }
  $$(".nav-live").forEach(function (a) {
    if (a.parentNode && a.parentNode.id === "drawer") return;
    a.setAttribute("href", TIKTOK); a.setAttribute("target", "_blank"); a.setAttribute("rel", "noopener");
    var s = $("span", a); if (s) s.textContent = lang === "es" ? "En vivo" : "Live";
  });
}

function renderPageHead() {
  if (!$("#page-h1")) return;
  var hd = (t().heads || {})[HERE];
  if (!hd) return;
  head(hd.h + " \u00b7 Lucerna Miami", hd.lede);
  set("page-h1", words(hd.h));
  txt("page-lede", hd.lede);
  set("crumbs", '<a href="' + P("home") + '">' + esc(t().nav.home) + "</a>" +
    '<span aria-hidden="true">/</span><span>' + esc(hd.h) + "</span>");
}

function renderHero() {
  if (!$("#hero-h1")) return;
  var h = t().hero;
  head(t().seo.title, t().seo.desc);
  txt("hero-eyebrow", h.eyebrow);
  /* The three lines are separate blocks, so the whitespace between them
     has to be written in. Without it the headline reads to a crawler —
     and to a screen reader — as one unbroken word. */
  set("hero-h1", '<span class="l">' + words(h.l1) + '</span> <span class="l">' + words(h.l2) +
                 '</span> <span class="l">' + words(h.l3) + "</span>");
  txt("hero-sub", h.sub);
  var c1 = $("#hero-cta1"), c2 = $("#hero-cta2");
  if (c1) { $("span", c1).textContent = h.cta1; c1.href = P("custom"); }
  if (c2) { $("span", c2).textContent = h.cta2; c2.href = P("book"); }
  txt("hero-scroll", lang === "es" ? "Desliza" : "Scroll");
  /* Each hero stone sits in a well of its own, exactly as the tiles do.
     The stones are photographed on black, and a screen blend needs a
     dark backdrop of its own to land on — the hero's own ancestors each
     open a stacking context, so the blend would otherwise have nothing
     but transparency behind it and the black ground would read as a
     box on the page. The wells are round, and small enough that the
     rings keep turning outside them. */
  var st = $("#hero-stone");
  if (st && st.dataset.built) {
    /* Same two stones in both languages; only the description differs. */
    var hi = st.querySelectorAll("img");
    if (hi[0]) hi[0].alt = lang === "es"
      ? "Diamante champaña talla mina antigua, cultivado en laboratorio, certificado IGI"
      : "Champagne old mine cut laboratory-grown diamond, IGI certified";
    if (hi[1]) hi[1].alt = lang === "es" ? "Diamante azul talla baguette" : "Fancy blue baguette diamond";
    return;
  }
  if (st) st.dataset.built = "1";
  if (st) st.innerHTML =
    '<span class="well main"><img src="' + (CFG.hero || STONE("38-old-mine", "-md")) +
      '" width="760" height="760" ' + STONE_SET("38-old-mine", false) + STONE_FALL("38-old-mine", "-md") +
      ' style="filter:url(#tint-champagne-deep)" alt="' +
      (lang === "es" ? "Diamante champaña talla mina antigua, cultivado en laboratorio, certificado IGI"
                     : "Champagne old mine cut laboratory-grown diamond, IGI certified") + '"></span>' +
    '<span class="well mini"><img src="' + (CFG.heroMini || STONE("23-baguette", "-sm")) +
      '" width="300" height="300" ' + STONE_SET("23-baguette", true) + STONE_FALL("23-baguette", "-sm") +
      ' style="filter:url(#tint-blue-deep)" alt="' +
      (lang === "es" ? "Diamante azul talla baguette" : "Fancy blue baguette diamond") + '"></span>';
}

function renderTicker() {
  var n = $("#ticker"); if (!n) return;
  var row = '<b>' + esc(t().ticker).split(" · ").join("</b><b>") + "</b>";
  n.innerHTML = row + row;
}

function renderBadges() {
  var n = $("#badges"); if (!n) return;
  n.innerHTML = t().badges.map(function (b) {
    return "<div><u>" + esc(b.k) + "</u><b>" + esc(b.t) + "</b><span>" + esc(b.s) + "</span></div>";
  }).join("");
}

function renderSimpleHead(prefix, obj) {
  txt(prefix + "-eyebrow", obj.eyebrow);
  set(prefix + "-h", words(obj.h));
  var b = $("#" + prefix + "-body"); if (b && obj.body) b.textContent = obj.body;
}

/* ───────────────────────── the book ───────────────────────── */
var bookColor = "white", bookShape = "all";
function renderBook() {
  var grid = $("#cut-grid"); if (!grid) return;
  var s = t().selection;
  renderSimpleHead("sel", s);
  var SHAPES = [["all", s.shapeAll], ["round", s.shapeRound], ["oval", s.shapeOval],
                ["pear", s.shapePear], ["marquise", s.shapeMarquise], ["square", s.shapeSquare],
                ["geometric", s.shapeGeometric], ["side", s.shapeSide]];
  /* The Book's own page opens on its h1 and then straight into the
     tray, which left a step missing in the heading order. This names
     the grid — and names it differently from the home page, so the two
     are not two copies of one sentence. */
  txt("book-grid-h", lang === "es"
        ? "Las treinta y nueve tallas, en diez colores"
        : "All thirty-nine cuts, in ten colors");
  txt("f-color-label", s.fColor); txt("f-shape-label", s.fShape);
  set("f-color", COLORS.map(function (c) {
    return '<button class="chip" data-color="' + c.key + '" style="--c:' + c.hex + '" aria-pressed="' +
      (c.key === bookColor) + '"><i></i>' + esc(c[lang]) + "</button>";
  }).join(""));
  set("f-shape", SHAPES.map(function (x) {
    return '<button class="chip plain" data-shape="' + x[0] + '" aria-pressed="' +
      (x[0] === bookShape) + '">' + esc(x[1]) + "</button>";
  }).join(""));
  paintBook();
}
function paintBook() {
  var grid = $("#cut-grid"); if (!grid) return;
  var s = t().selection;
  var list = CUTS.filter(function (c) { return bookShape === "all" || c.fam === bookShape; });
  var col = COLORS.filter(function (c) { return c.key === bookColor; })[0] || COLORS[0];
  setSel(bookColor);
  var order = list.map(function (c) { return c.slug; }).join(",");
  /* A colour chip and a language switch both change only words and a
     tint — the stones themselves are the same stones. Rewriting the
     tray's markup makes the browser throw away thirty-nine decoded
     images and fetch, decode and lay them out again, which is the whole
     of the delay a visitor feels on the tap. So when the set of stones
     has not changed, the existing tiles are edited where they stand and
     not one src is touched. */
  if (list.length && grid.dataset.order === order) {
    var tiles = grid.children;
    for (var i = 0; i < list.length; i++) {
      var c = list[i], el = tiles[i]; if (!el) break;
      var im = el.querySelector("img"), h3 = el.querySelector("h3"), p = el.querySelector("p");
      var want = "url(#tint-" + col.key + ")";
      if (im) {
        if (im.style.filter !== want) im.style.filter = want;
        im.alt = c[lang] + " — " + col[lang];
      }
      if (h3 && h3.textContent !== c[lang]) h3.textContent = c[lang];
      if (p) p.textContent = c.facets + " " + s.facets;
      var sr = el.querySelector(".sr");
      if (sr) sr.textContent = s.house;
    }
  }
  else if (!list.length) { grid.innerHTML = '<p class="empty">' + esc(s.none) + "</p>"; grid.dataset.order = ""; }
  else {
    grid.dataset.order = order;
    grid.innerHTML = list.map(function (c) {
      /* No reveal class on a tile: the reveal animates opacity, an
         element with opacity below one isolates its blending, and the
         stone's ground would flash as a black square on the way in. */
      return '<article class="cut' + (c.house ? " is-house" : "") + '">' +
        /* A house shape is marked by setting its name in gold rather
           than by a dot floating over the stone — on a tile this size a
           dot reads as a speck of dust. The words stay for anyone
           reading with their ears. */
        (c.house ? '<span class="sr">' + esc(s.house) + "</span>" : "") +
        '<figure><img loading="lazy" decoding="async" width="380" height="380" src="' +
        STONE(c.slug, "-sm") + '"' + STONE_SET(c.slug, true) + STONE_FALL(c.slug, "-sm") +
        ' style="filter:url(#tint-' + col.key + ')" alt="' +
        esc(c[lang]) + " — " + esc(col[lang]) + '"></figure>' +
        "<h3>" + esc(c[lang]) + "</h3><p>" + c.facets + " " + esc(s.facets) + "</p></article>";
    }).join("");
  }
  var meta = $("#book-meta");
  if (meta) meta.innerHTML = "<span>" + list.length + " " + esc(s.count) + "</span><span>" +
    esc(col[lang]) + " · " + esc(col["grade_" + lang]) + "</span>";
  $$("#f-color .chip").forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.color === bookColor)); });
  $$("#f-shape .chip").forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.shape === bookShape)); });
  /* Only on The Book itself: the home page shows the same tray but
     is not the reference page, and one paragraph belongs to one. */
  if (HERE === "book") txt("book-note", s.note);
  watch();
}
document.addEventListener("click", function (e) {
  var c = e.target.closest && e.target.closest("[data-color]");
  if (c) { bookColor = c.dataset.color; paintBook(); return; }
  var sh = e.target.closest && e.target.closest("[data-shape]");
  if (sh) { bookShape = sh.dataset.shape; paintBook(); }
});

/* ───────────────────────── the diamond ───────────────────────── */
function renderStone() {
  if (!$("#stone-h")) return;
  var s = t().stone;
  renderSimpleHead("stone", s);
  txt("stone-lede", s.lede);
  set("stone-tbl",
    "<thead><tr><th></th><th>" + esc(s.colLab) + "</th><th>" + esc(s.colMine) + "</th></tr></thead><tbody>" +
    s.rows.map(function (r) {
      return "<tr><td>" + esc(r[0]) + '</td><td class="v">' + esc(r[1]) + '</td><td class="m">' + esc(r[2]) + "</td></tr>";
    }).join("") + "</tbody>");
  txt("stone-candor", s.candor);
}
function renderVocab() {
  if (!$("#vocab-h")) return;
  var v = t().vocab;
  renderSimpleHead("vocab", v);
  set("vocab-cards", v.items.map(function (it, i) {
    return '<div class="card rev" data-d="' + (i % 4) + '"><u>' + ["I", "II", "III", "IV"][i] +
      "</u><h3>" + esc(it.t) + "</h3><p>" + esc(it.b) + "</p></div>";
  }).join(""));
}
function renderCert() {
  if (!$("#cert-h")) return;
  var c = t().cert;
  renderSimpleHead("cert", c);
  set("cert-lines", c.lines.map(function (l) {
    return "<div><dt>" + esc(l[0]) + "</dt><dd>" + esc(l[1]) + "</dd></div>";
  }).join(""));
  txt("cert-habit", c.habit);
}
function renderRecord() {
  if (!$("#record-h")) return;
  var r = t().record;
  renderSimpleHead("record", r);
  set("record-panel",
    '<div class="panel-h"><b>' + esc(r.title) + "</b><span>" + esc(r.tag) + "</span></div>" +
    '<table class="tbl"><tbody>' + r.rows.map(function (x) {
      return "<tr><td>" + esc(x[0]) + '</td><td class="v">' + esc(x[1]) + "</td></tr>";
    }).join("") + "</tbody></table>" +
    '<p class="note" style="margin-top:18px">' + esc(r.note) + "</p>");
}
function renderDays() {
  if (!$("#days-h")) return;
  var d = t().days;
  renderSimpleHead("days", d);
  set("days-tbl",
    "<thead><tr><th>" + esc(d.colStage) + "</th><th>" + esc(d.colDays) + "</th></tr></thead><tbody>" +
    d.stages.map(function (s) { return "<tr><td>" + esc(s[0]) + '</td><td class="v">' + esc(s[1]) + "</td></tr>"; }).join("") +
    '<tr><td><strong>' + esc(d.total) + '</strong></td><td class="v"><strong>' + esc(d.totalV) + "</strong></td></tr></tbody>");
  txt("days-bartitle", d.barTitle);
  set("days-key",
    '<span><u style="background:linear-gradient(100deg,var(--gold-hi),var(--gold))"></u>' + esc(d.keyGrowth) + "</span>" +
    '<span><u style="background:var(--gold-lo)"></u>' + esc(d.keyCutting) + "</span>" +
    '<span><u style="background:var(--line-2)"></u>' + esc(d.keyIgi) + "</span>");
  txt("days-hourslabel", d.hoursLabel); txt("days-hoursbody", d.hoursBody);
  set("days-pull", esc(d.pull) + "<br><em>" + esc(d.pull2) + "</em>");
}

/* ───────────────────────── made to order ───────────────────────── */
function renderBespoke() {
  if (!$("#bespoke-h")) return;
  var b = t().bespoke;
  renderSimpleHead("bespoke", b);
  /* Four claims, set the way a watchmaker sets a specification: a term
     on the left, the fact on the right, a hairline between. Numbering
     them I to IV implied an order they do not have, and four cards of
     equal weight said nothing about which mattered. */
  var SPEC = b.specLabels || ["Design", "Metal", "Finish", "The stone"];
  set("bespoke-offers", b.offers.map(function (o, i) {
    return '<div class="sheet-row rev" data-d="' + Math.min(i, 3) + '">' +
      '<dt>' + esc(SPEC[i] || "") + "</dt>" +
      "<dd><b>" + esc(o[0]) + "</b> " + esc(o[1]) + "</dd></div>";
  }).join(""));
}
/* ───────────────────────── house / doors / live ───────────────────────── */
function renderDoors() {
  if (!$("#pages-h")) return;
  var p = t().pages;
  /* The house seals its own page before naming the rooms behind it. */
  $$(".crest svg").forEach(function (s) {
    s.outerHTML = markSvg('width="76" height="76"', { r: 168, w: 1.9, hair: .42 });
  });
  renderSimpleHead("pages", p);
  var href = { book: "book", vault: "vault", diamond: "diamond", order: "custom", journal: "journal", house: "house" };
  set("doors", p.items.map(function (it, i) {
    return '<a class="door rev" data-d="' + (i % 3) + '" href="' + P(href[it.k] || "home") + '">' +
      "<u>" + esc(it.s) + "</u><h3>" + esc(it.t) + "</h3><p>" + esc(it.b) + "</p></a>";
  }).join(""));
}
function renderLive() {
  if (!$("#live-h")) return;
  var l = t().live;
  renderSimpleHead("live", l);
  txt("live-soon", l.soon); txt("live-soonbody", l.soonBody);
  var a = $("#live-cta"); if (a) { $("span", a).textContent = l.cta; a.href = TIKTOK; }
  txt("live-ctasub", l.ctaSub);
}
function renderVault() {
  if (!$("#vault-h")) return;
  var v = t().vault;
  renderSimpleHead("vault", v);
  txt("vault-soon", v.soon);
  var a = $("#vault-cta"); if (a) { $("span", a).textContent = v.cta; a.href = TIKTOK; }
  var b = $("#vault-alt"); if (b) { $("span", b).textContent = v.alt; b.href = P("contact"); }
}
function renderEthics() {
  if (!$("#ethics-h")) return;
  var e = t().ethics;
  renderSimpleHead("ethics", e);
  set("ethics-cards", e.items.map(function (it, i) {
    return '<div class="card rev" data-d="' + (i % 4) + '"><u>' + ["I", "II", "III", "IV"][i] +
      "</u><h3>" + esc(it[0]) + "</h3><p>" + esc(it[1]) + "</p></div>";
  }).join(""));
}
function renderFaq() {
  var n = $("#faq-list"); if (!n) return;
  var f = t().faq;
  renderSimpleHead("faq", f);
  n.innerHTML = f.items.map(function (x) {
    return "<details><summary>" + esc(x[0]) + '</summary><div class="faq-a">' + esc(x[1]) + "</div></details>";
  }).join("");
}
function renderCabinet() {
  if (!$("#cab-h")) return;
  var c = t().cabinet;
  renderSimpleHead("cab", c);
  txt("cab-soon", c.soon);
  var a = $("#cab-cta"); if (a) { $("span", a).textContent = c.cta; a.href = TIKTOK; }
  var b = $("#cab-alt"); if (b) { $("span", b).textContent = c.alt; b.href = P("custom"); }
}
/* Article bodies come from Shopify's editor and are put into the page as
   HTML, which is what makes them read like a magazine rather than a
   textarea. Anything that can execute is taken out first. The house
   writes its own Journal, so this is not about distrusting the author --
   it is that a post can be pasted from somewhere else, and a staff member
   with blog access should not thereby be able to run code on the shop. */
function scrubArticle(html) {
  return String(html || "")
    .replace(/<\/?(script|style|iframe|object|embed|form|input|link|meta|base)\b[^>]*>/gi, "")
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/(href|src|xlink:href)\s*=\s*("|')\s*javascript:[^"']*\2/gi, '$1="#"');
}
function renderJournal() {
  var list = $("#jr-list"); if (!list) return;
  var j = t().journal;
  renderSimpleHead("jr", j);
  var a = $("#jr-cta"); if (a) { $("span", a).textContent = j.cta; a.href = P("custom"); }

  /* The Journal is a record of real commissions, so it is not written
     here -- it is written in Shopify and read from there. Until a piece
     is published the page says so plainly rather than showing invented
     work, and if the Worker is not connected it says the same thing. A
     journal that fabricates entries is worse than an empty one. */
  var when = function (iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleDateString(lang === "es" ? "es-ES" : "en-US",
        { year: "numeric", month: "long", day: "numeric" });
    } catch (e) { return ""; }
  };
  var done = function (posts) {
    if (!posts || !posts.length) {
      list.innerHTML = "";
      txt("jr-empty", j.empty);
      var end = $(".jr-end"); if (end) end.style.display = "";
      return;
    }
    txt("jr-empty", "");
    list.innerHTML = posts.map(function (p, i) {
      var img = p.image
        ? '<figure class="jrn-shot">' +
          '<img loading="lazy" decoding="async" width="520" height="390" src="' + esc(p.image) +
          '" alt="' + esc(p.alt || p.title) + '"></figure>'
        : "";
      return '<article class="jrn-item jrn-post rev" data-d="' + Math.min(i, 3) + '">' +
        img +
        '<div class="jrn-body">' +
          (when(p.date) ? '<p class="jrn-date">' + esc(when(p.date)) + "</p>" : "") +
          "<h2>" + esc(p.title) + "</h2>" +
          (p.summary ? '<p class="jrn-s">' + esc(p.summary) + "</p>" : "") +
          /* The piece opens here. Sending a customer to a myshopify.com
             address to read about their own ring would hand them a
             different brand mid-sentence. */
          (p.body ? '<div class="jrn-full" hidden>' + scrubArticle(p.body) + "</div>" +
                    '<p class="jrn-more"><button type="button" class="jrn-open">' +
                      esc(j.readMore) + "</button></p>" : "") +
        "</div></article>";
    }).join("");
    $$(".jrn-post", list).forEach(function (n) { n.classList.add("r-in"); });
    $$(".jrn-open", list).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var full = $(".jrn-full", btn.closest(".jrn-post"));
        if (!full) return;
        var open = !full.hidden;
        full.hidden = open;
        btn.textContent = open ? j.readMore : j.back;
      });
    });
  };

  /* On Shopify the Journal is the store's own blog. Liquid writes the
     articles into the page as JSON, so there is nothing to fetch. */
  var inline = document.getElementById("lux-journal");
  if (inline) {
    var posts = null;
    try { posts = JSON.parse(inline.textContent || "[]"); } catch (e) {}
    done(posts);
    return;
  }
  if (!API) { done(null); return; }
  txt("jr-empty", j.loading);
  fetch(API.replace(/\/+$/, "") + "/journal?lang=" + encodeURIComponent(lang))
    .then(function (r) { return r.json(); })
    .then(function (r) { done(r && r.ok ? r.entries : null); })
    .catch(function () { done(null); });
}
function renderContact() {
  if (!$("#ct-h")) return;
  var c = t().contact;
  renderSimpleHead("ct", c);
  set("ct-grid",
    "<div><dt>" + esc(c.email) + '</dt><dd><a href="mailto:' + EMAIL + '">' + EMAIL + "</a></dd></div>" +
    "<div><dt>" + esc(c.tiktok) + '</dt><dd><a href="' + TIKTOK + '" target="_blank" rel="noopener">@lucernadiamonds</a></dd></div>' +
    "<div><dt>" + esc(c.hours) + "</dt><dd>" + esc(c.hoursV) + "</dd></div>" +
    "<div><dt>" + esc(c.replies) + "</dt><dd>" + esc(c.repliesV) + "</dd></div>");
  txt("ct-city", c.cityLine); txt("ct-blurb", c.blurb);
}

function renderFooter() {
  var f = t().footer, n = t().nav, lg = t().legal;
  $$(".foot-mark svg").forEach(function (s) {
    s.outerHTML = markSvg('width="44" height="44"', { r: 168, w: 2.6, hair: .5 });
  });
  txt("foot-tag", f.tagline);
  txt("foot-blurb", t().contact.blurb);
  set("foot-c1", "<h2>" + esc(lang === "es" ? "La casa" : "The house") + "</h2>" +
    ["book", "diamond", "custom", "journal"].map(navLink).join(""));
  set("foot-c2", "<h2>" + esc(lang === "es" ? "Más" : "More") + "</h2>" +
    ["vault", "journal", "house", "careers"].map(navLink).join(""));
  set("foot-c3", "<h2>" + esc(lang === "es" ? "Legal" : "Legal") + "</h2>" +
    '<a href="' + PAGE("terms") + (lang === "en" ? "?lang=en" : "") + '">' + esc(lg.terms) + "</a>" +
    '<a href="' + PAGE("privacy") + (lang === "en" ? "?lang=en" : "") + '">' + esc(lg.privacy) + "</a>" +
    '<a href="' + PAGE("shipping") + (lang === "en" ? "?lang=en" : "") + '">' + esc(lg.shipping) + "</a>" +
    '<a href="' + P("contact") + '">' + esc(n.contact) + "</a>");
  txt("foot-disc", lg.disclaimer);
  txt("foot-rights", "© " + new Date().getFullYear() + " Lucerna Miami · " + f.rights);
  txt("foot-line", f.line);
}

/* ══════════════════════════════════════════════════════════════════
   FILM
   A band only fetches its film when it is nearly on screen, and only
   plays while it is. Eight of these on one page would otherwise be
   eight video streams running behind the fold on somebody's phone.

   The poster is a still of the same stone. It is placed by hand rather
   than through the video's own poster attribute, because these stones
   are cut out and a poster is drawn edge to edge — centred on its own
   bed it reads as a lit object instead of a stretched one.
   ══════════════════════════════════════════════════════════════════ */
function renderFilm() {
  var bands = $$(".film");
  if (!bands.length) return;
  var FILMS = CFG.films || {};
  var copy = t().films || {};

  bands.forEach(function (band) {
    var key = band.dataset.film;
    txt("film-" + key, copy[key] || "");

    var bed = $(".film-bed", band);
    if (bed && !$(".still", bed)) {
      var slug = band.dataset.poster;
      var still = document.createElement("img");
      still.className = "still";
      still.src = STONE(slug, "-md");
      still.alt = "";
      /* Dimensions even though the still is absolutely positioned: the
         box is reserved before the bytes land, which is what keeps the
         band from settling under the reader as it loads. */
      still.width = 512; still.height = 512;
      still.decoding = "async";
      still.setAttribute("aria-hidden", "true");
      still.onerror = function () { still.src = ASSET(slug + "-md.webp"); };
      bed.insertBefore(still, bed.firstChild);
    }
  });

  var src = FILMS;
  if (!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function (rows) {
    rows.forEach(function (r) {
      var band = r.target, v = $(".film-v", band);
      if (!v) return;
      var url = src[band.dataset.film];
      if (!r.isIntersecting) { if (!v.paused) v.pause(); return; }
      if (url && !v.getAttribute("src")) {
        v.addEventListener("loadeddata", function () { band.classList.add("ready"); });
        v.setAttribute("src", url);
        v.load();
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }, { rootMargin: "25% 0px", threshold: 0.01 });
  bands.forEach(function (b) { io.observe(b); });
}

/* ══════════════════════════════════════════════════════════════════
   SCATTER — stones through the room

   The pages read as columns of words because the only stones on the
   site were in the tray. A house's pages are not essays; they have the
   goods lying about in them, at the edges, out of the way of the
   reading but never far from it.

   So every room gets a handful: different cuts, different colours,
   different sizes, placed in the margins where the text is not, drawn
   from the same thirty-nine files already on the page. They drift on
   long uneven clocks, and a hard light rakes slowly across each one so
   the facets catch and let go — the animation, built from real
   photographs rather than invented footage.

   They are decoration and they say so: aria-hidden, lazy, never in the
   way of a pointer, and completely still when the reader asks for
   stillness.
   ══════════════════════════════════════════════════════════════════ */
function MASK(slug) {
  try { return new URL(ASSET(slug + "-xs.webp"), location.href).href; }
  catch (e) { return ASSET(slug + "-xs.webp"); }
}
function scatter() {
  if (!document.body) return;
  /* renderAll runs again on a language switch, so the old scatter is
     cleared rather than added to. */
  var room = HERE;
  /* The scatter is the same in both languages — it carries no words at
     all — so once it is placed it is left alone. Removing and rebuilding
     it on a language switch costs four image decodes for no change. */
  var had = $("#scatter");
  if (had && had.dataset.room === room) return;
  $$("#scatter").forEach(function (n) { n.remove(); });

  /* Hand-placed per room, in the gutters each layout actually leaves
     empty. Percentages, so they hold at every width. x/y are the
     anchor, s the size in vw, r the tilt, d the clock. */
  var PLAN = {
    home:    [["09-pear","pink",6,26,5.4,-14,0],["31-kite","blue",92,48,4.2,18,3],
              ["18-cushion","champagne",4,62,5,8,6],["12-heart","green",95,74,3.6,-10,2]],
    book:    [["20-emerald","yellow",5,18,4.4,12,1],["35-half-moon","orange",94,36,3.8,-16,4]],
    diamond: [["01-round-brilliant","white",93,14,5.6,0,0],["13-marquise","purple",5,40,4.4,22,3],
              ["38-old-mine","brown",92,66,5,-12,5],["23-baguette","blue",6,82,3.4,14,1]],
    custom:  [["17-princess","white",94,20,4.6,-8,2],["09-pear","yellow",4,46,4.2,16,5],
              ["21-asscher","green",93,78,4,10,0]],
    vault:   [["18-cushion","pink",5,22,5.2,-12,1],["31-kite","gray",93,52,4,20,4],
              ["12-heart","champagne",6,76,4.4,-6,2]],
    house:   [["38-old-mine","champagne",94,18,5,14,0],["20-emerald","blue",4,44,4.2,-18,3],
              ["01-round-brilliant","white",93,72,4.6,6,5]],
    journal: [["13-marquise","yellow",4,16,4,18,2],["35-half-moon","pink",95,40,3.6,-14,0],
              ["21-asscher","brown",5,68,4.4,10,4]],
    careers: [["09-pear","green",94,26,4.4,-10,1],["31-kite","orange",5,58,3.8,16,3]],
    contact: [["12-heart","pink",93,22,4.6,12,0],["23-baguette","white",5,54,3.4,-18,4],
              ["18-cushion","purple",94,80,4.2,8,2]],
    legal:   [["01-round-brilliant","gray",95,30,3.6,0,1],["20-emerald","champagne",4,66,3.4,14,3]]
  };
  var plan = PLAN[room] || PLAN.legal;
  if (!plan || !plan.length) return;

  var box = document.createElement("div");
  box.id = "scatter";
  box.dataset.room = room;
  box.setAttribute("aria-hidden", "true");
  box.innerHTML = plan.map(function (p) {
    var slug = p[0], col = p[1], x = p[2], y = p[3], s = p[4], r = p[5], d = p[6];
    return '<i class="sct" style="left:' + x + "%;top:" + y + "%;--s:" + s +
      "vw;--r:" + r + "deg;--d:" + d + 's">' +
      /* Fixed to the viewport, so every one of these is above the fold on
         every page: lazy was the wrong instruction and it showed — one
         arrived at three seconds and became the largest thing the page
         had painted. They are five kilobytes each; they load with the
         page, at a priority that does not elbow the words aside. */
      '<img loading="eager" fetchpriority="low" decoding="async" width="96" height="96" alt="" src="' +
      ASSET(slug + "-xs.webp") + '" style="filter:url(#tint-' + col +
      ') saturate(1.15) brightness(1.5) drop-shadow(0 14px 24px rgba(0,0,0,.5))">' +
      /* The light sweep used to be a square laid over the stone, kept
         invisible only by a blend mode. Masked to the stone's own
         silhouette it needs no blending at all, and there is no square
         left anywhere to show. */
      /* Absolute, deliberately. A relative url() handed through a custom
         property is resolved against the stylesheet that consumes it,
         not the document, so "assets/x.webp" became "/assets/assets/x.webp"
         and every mask quietly 404'd. */
      '<b class="rake" style="--m:url(' + MASK(slug) + ')"></b></i>';
  }).join("");
  document.body.appendChild(box);
}

/* ══════════════════════════════════════════════════════════════════
   THE CONFIGURATOR
   The browser is told what a setting costs so it can show a number.
   It is never believed: the Worker recomputes the charge from its own
   copy of this table before any checkout is created.
   ══════════════════════════════════════════════════════════════════ */
var cfg = { metal: null, piece: null, style: null, band: null, back: null };

function pieceOf(k) { return PIECES.filter(function (p) { return p.k === k; })[0]; }
function quote() {
  if (!PRICES || !cfg.metal || !cfg.piece || !cfg.style) return null;
  var pc = pieceOf(cfg.piece); if (!pc) return null;
  var st = pc.styles.filter(function (s) { return s.k === cfg.style; })[0]; if (!st) return null;
  if (pc.backs && !cfg.back) return null;
  if (!pc.noStone && !cfg.band) return null;
  var m = PRICES.metals.filter(function (x) { return x.k === cfg.metal; })[0];
  var ci = PRICES.pieces.map(function (x) { return x.k; }).indexOf(st.col);
  var bi = PRICES.bands.map(function (x) { return x.k; }).indexOf(st.band || cfg.band);
  if (!m || ci < 0 || bi < 0) return null;
  var row = (PRICES.table[m.table] || [])[bi];
  if (!row || row[ci] == null) return null;
  return {
    amount: row[ci] + (st.add || 0),
    metal: m[lang], piece: pc[lang],
    style: pc.styles.length > 1 ? st[lang] : null,
    band: pc.noStone ? null : PRICES.bands[bi][lang],
    back: pc.backs ? (pc.backs.filter(function (b) { return b.k === cfg.back; })[0] || {})[lang] : null,
    noStone: !!pc.noStone
  };
}

function renderConfig() {
  if (!$("#cfg-h")) return;
  var c = t().config;
  renderSimpleHead("cfg", c);
  var pc = cfg.piece ? pieceOf(cfg.piece) : null;
  var qs = [];

  qs.push(q(1, c.q1, c.q1b, PRICES.metals.map(function (m) {
    return opt("metal", m.k, m[lang]);
  }).join("")));

  qs.push(q(2, c.q2, c.q2b, PIECES.map(function (p) {
    return opt("piece", p.k, p[lang]);
  }).join("")));

  if (pc) qs.push(q(3, c.q3, c.q3b, pc.styles.map(function (s) {
    return opt("style", s.k, s[lang]);
  }).join("")));

  if (pc && !pc.noStone) qs.push(q(4, c.q4, c.q4b, PRICES.bands.map(function (b) {
    return opt("band", b.k, b[lang]);
  }).join("")));

  if (pc && pc.backs) qs.push(q(5, c.q5, c.q5b, pc.backs.map(function (b) {
    return opt("back", b.k, b[lang]);
  }).join("")));

  set("cfg-qs", qs.join(""));
  paintTicket();

  function q(n, label, hint, body) {
    return '<div class="q"><div class="q-top"><b>' + esc(label) + "</b></div>" +
      '<p class="q-hint">' + esc(hint) + '</p><div class="opts">' + body + "</div></div>";
  }
  function opt(key, val, label) {
    return '<button class="opt" data-cfg="' + key + '" data-val="' + esc(val) + '" aria-pressed="' +
      (cfg[key] === val) + '">' + esc(label) + "</button>";
  }
}

function paintTicket() {
  var c = t().config, tk = $("#cfg-ticket"); if (!tk) return;
  var Q = quote(), pc = cfg.piece ? pieceOf(cfg.piece) : null;
  var money = function (n) { return "$" + n.toLocaleString(lang === "es" ? "es-US" : "en-US"); };
  var spec = "";
  if (Q) {
    spec = '<dl class="spec">' +
      row(c.q1, Q.metal) + row(c.q2, Q.piece) +
      (Q.style ? row(c.q3, Q.style) : "") +
      (Q.band ? row(c.q4, Q.band) : "") +
      (Q.back ? row(c.q5, Q.back) : "") + "</dl>";
  }
  tk.innerHTML =
    '<p class="cap">' + esc(c.totalT) + "</p>" +
    '<p class="amt' + (Q ? "" : " empty") + '">' + (Q ? money(Q.amount) : esc(c.pick)) + "</p>" +
    '<p class="note">' + esc(Q && Q.noStone ? c.noChain : c.noStone) + "</p>" +
    spec +
    (Q ? '<ul class="inc">' + c.included.map(function (i) { return "<li>" + esc(i) + "</li>"; }).join("") + "</ul>" : "") +
    '<div class="cta-row" style="margin-top:28px">' +
      '<button class="btn btn-gold" id="cfg-go"' + (Q ? "" : " disabled") + ' style="width:100%"><span>' +
      esc(CHECKOUT ? c.cta : c.ctaQuote) + "</span></button></div>" +
    '<p class="note" id="cfg-msg" style="margin-top:14px">' + esc(c.madeIn) + "</p>" +
    (Q ? '<p class="note" style="margin-top:10px">' + esc(pc && pc.noStone ? c.noChainB : c.noStoneB) + "</p>" : "");
  function row(k, v) { return "<div><dt>" + esc(k) + "</dt><dd>" + esc(v) + "</dd></div>"; }
}

document.addEventListener("click", function (e) {
  var o = e.target.closest && e.target.closest("[data-cfg]");
  if (o) {
    var k = o.dataset.cfg, v = o.dataset.val;
    cfg[k] = cfg[k] === v ? null : v;
    if (k === "piece") { cfg.style = null; cfg.band = null; cfg.back = null; }
    renderConfig();
    return;
  }
  if (e.target.closest && e.target.closest("#cfg-go")) submitConfig();
});

function submitConfig() {
  var c = t().config, Q = quote(); if (!Q) return;
  var btn = $("#cfg-go"), msg = $("#cfg-msg");
  if (!CHECKOUT) {
    msg.textContent = c.quoteOk + " " + c.quoteBody;
    return;
  }
  btn.disabled = true; $("span", btn).textContent = c.busy;
  if (CHECKOUT === "cart") { cartCheckout(Q, btn, msg, c); return; }
  post("/checkout", {
    metal: cfg.metal, piece: cfg.piece, style: cfg.style, band: cfg.band, back: cfg.back,
    lang: lang, page: location.href
  }).then(function (r) {
    if (r && r.url) { location.href = r.url; return; }
    msg.textContent = c.quoteOk + " " + c.quoteBody;
    btn.disabled = true; $("span", btn).textContent = c.ctaQuote;
  }).catch(function () {
    msg.textContent = c.quoteOk + " " + c.quoteBody;
    btn.disabled = false; $("span", btn).textContent = c.ctaQuote;
  });
}

/* ── checkout, entirely inside Shopify ────────────────────────────────
   Each style is a product named  <prefix><piece>-<style>  whose variants
   are metal x stone size, each carrying a SKU built the same way here.
   The page finds the variant by SKU, adds it with the full specification
   as line-item properties, and sends the customer to Shopify checkout.
   The price charged is the variant's own price, set in Shopify. */
function cartSku() {
  var pc = pieceOf(cfg.piece), st = pc.styles.filter(function (s) { return s.k === cfg.style; })[0];
  var parts = ["LUX", cfg.piece, cfg.style, cfg.metal];
  if (!pc.noStone) {
    var bi = PRICES.bands.map(function (x) { return x.k; }).indexOf(st.band || cfg.band) + 1;
    parts.push("B" + (bi < 10 ? "0" : "") + bi);
  }
  return parts.join("-").toUpperCase();
}
function cartCheckout(Q, btn, msg, c) {
  var root = CART.root || "/", pc = pieceOf(cfg.piece);
  var st = pc.styles.filter(function (s) { return s.k === cfg.style; })[0];
  var handle = (CART.prefix || "lucerna-") + cfg.piece + "-" + cfg.style;
  var sku = cartSku();
  var fail = function () {
    msg.textContent = c.quoteOk + " " + c.quoteBody;
    btn.disabled = false; $("span", btn).textContent = c.ctaQuote;
  };
  var metal = PRICES.metals.filter(function (x) { return x.k === cfg.metal; })[0] || {};
  var band = pc.noStone ? null : PRICES.bands.filter(function (x) { return x.k === (st.band || cfg.band); })[0];
  var back = pc.backs ? (pc.backs.filter(function (b) { return b.k === cfg.back; })[0] || {}) : null;
  var props = { "Piece": pc.en, "Metal": metal.en || cfg.metal };
  if (pc.styles.length > 1) props["Style"] = st.en;
  if (band) props["Stone size"] = band.en;
  if (back) props["Back"] = back.en;
  props["Language"] = lang === "es" ? "Spanish" : "English";
  props["Configured on"] = location.href.split("#")[0];
  fetch(root + "products/" + handle + ".js", { headers: { Accept: "application/json" } })
    .then(function (r) { if (!r.ok) throw new Error("no-product"); return r.json(); })
    .then(function (p) {
      var v = (p.variants || []).filter(function (x) { return String(x.sku).toUpperCase() === sku; })[0];
      if (!v || !v.available) throw new Error("no-variant");
      return fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error("no-cart");
        /* The page and the chart agree: straight to checkout. If they
           ever drift, the customer lands in the cart where the real
           price is plain to see, rather than being charged blind. */
        var agree = Math.round(v.price) === Math.round(Q.amount * 100);
        location.href = root + (agree ? "checkout" : "cart");
      });
    }).catch(fail);
}

/* ══════════════════════════════════════════════════════════════════
   THE BACKEND
   Nothing here knows an API key. Everything goes through the Worker.
   With no Worker configured the forms still validate and still tell
   the visitor what happens next — they simply mail instead.
   ══════════════════════════════════════════════════════════════════ */
function post(path, body) {
  if (!API) return Promise.reject(new Error("no-api"));
  return fetch(API.replace(/\/+$/, "") + path, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body)
  }).then(function (r) { return r.json(); });
}
function fileToB64(f) {
  return new Promise(function (res, rej) {
    var r = new FileReader();
    r.onload = function () { res(String(r.result).split(",")[1]); };
    r.onerror = rej; r.readAsDataURL(f);
  });
}
var okMail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
/* On Shopify the browser posts the form itself, once it is valid. */
function nativeGuard(e, f, sel, err) {
  if (CFG.forms !== "shopify") return false;
  var bad = false;
  $$("[required]", f).forEach(function (x) {
    var v = String(x.value || "").trim();
    if (!v || (x.type === "email" && !okMail.test(v))) bad = true;
  });
  if (f.company && f.company.value) { e.preventDefault(); bad = false; return true; }
  if (bad) {
    e.preventDefault();
    var m = $(sel);
    if (m) { m.style.color = "#D08A62"; m.textContent = err; }
  }
  return true;
}

/* ───────────────────────── commission form ───────────────────────── */
function renderCommission() {
  var f = $("#cm-form"); if (!f) return;
  var c = t().commission;
  renderSimpleHead("cm", c);
  f.innerHTML =
    '<input class="hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
    fld("cm-name", "text", c.fName, "name", true) +
    fld("cm-email", "email", c.fEmail, "email", true) +
    fld("cm-phone", "tel", c.fPhone, "tel") +
    fld("cm-tiktok", "text", c.fTikTok, "", false, c.fTikTokHint) +
    fld("cm-stone", "text", c.fStone, "", false, c.fStoneHint, true) +
    sel("cm-piece", c.fPiece, c.fPieceOpts, true) +
    area("cm-details", c.fDetails, c.fDetailsHint) +
    '<div class="field full"><div class="filepick">' +
      '<button type="button" id="cm-pick">' + esc(c.fFile) + "</button>" +
      '<span id="cm-fname">' + esc(c.fFileHint) + "</span>" +
      '<input id="cm-file" type="file" accept="image/*,.pdf" hidden aria-label="' + esc(c.fFile) + '"></div></div>' +
    '<div class="form-msg" id="cm-msg" role="status" aria-live="polite"></div>' +
    '<div class="field full"><button class="btn btn-gold" type="submit" style="width:100%"><span>' +
      esc(c.submit) + "</span></button></div>";
  txt("cm-quoted", c.quoted);

  var file = null;
  $("#cm-pick").addEventListener("click", function () { $("#cm-file").click(); });
  $("#cm-file").addEventListener("change", function (e) {
    file = e.target.files[0] || null;
    $("#cm-fname").textContent = file ? c.fFileChosen + " · " + file.name : c.fFileHint;
  });
  f.addEventListener("submit", function (e) {
    if (nativeGuard(e, f, "#cm-msg", c.required)) return;
    e.preventDefault();
    var msg = $("#cm-msg");
    if (f.company.value) { msg.textContent = c.okTitle + " " + c.okBody; return; }
    var name = $("#cm-name").value.trim(), mail = $("#cm-email").value.trim(), piece = $("#cm-piece").value;
    if (!name || !okMail.test(mail) || !piece) { msg.style.color = "#D08A62"; msg.textContent = c.required; return; }
    msg.style.color = "var(--gold)"; msg.textContent = c.sending;
    var send = function (att) {
      return post("/inquiry", {
        name: name, email: mail, phone: $("#cm-phone").value, tiktok: $("#cm-tiktok").value,
        stone: $("#cm-stone").value, piece: piece, details: $("#cm-details").value,
        lang: lang, page: location.href, attachment: att
      });
    };
    var go = file ? fileToB64(file).then(function (d) { return send({ filename: file.name, data: d }); }) : send(null);
    go.then(function (r) {
      if (r && r.ok) { msg.textContent = c.okTitle + " " + c.okBody; f.reset(); file = null;
        $("#cm-fname").textContent = c.fFileHint; }
      else { msg.textContent = c.okTitle + " " + c.okBody; }
    }).catch(function () { msg.textContent = c.okTitle + " " + c.okBody + " (" + EMAIL + ")"; });
  });
}

/* ───────────────────────── careers form ───────────────────────── */
function renderCareers() {
  if (!$("#cr-h")) return;
  var c = t().careers;
  renderSimpleHead("cr", c);
  txt("cr-what", c.what);
  set("cr-points", c.points.map(function (p, i) {
    return '<div class="card rev" data-d="' + (i % 4) + '"><u>' + ["I", "II", "III", "IV"][i] +
      "</u><h3>" + esc(p.t) + "</h3><p>" + esc(p.b) + "</p></div>";
  }).join(""));
  txt("cr-rolest", c.rolesT);
  txt("cr-formt", c.formT); txt("cr-formb", c.formB);
  txt("cr-privacy", c.privacy);
  var f = $("#cr-form"); if (!f) return;
  f.innerHTML =
    '<input class="hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
    fld("cr-name", "text", c.fName, "name", true) +
    fld("cr-email", "email", c.fEmail, "email", true) +
    fld("cr-phone", "tel", c.fPhone, "tel") +
    sel("cr-role", c.fRole, c.roles, false) +
    fld("cr-links", "text", c.fLinks, "", false, c.fLinksHint, true) +
    area("cr-note", c.fNote, c.fNoteHint) +
    '<div class="field full"><div class="filepick">' +
      '<button type="button" id="cr-pick">' + esc(c.fFilePick) + "</button>" +
      '<span id="cr-fname">' + esc(c.fFileHint) + "</span>" +
      '<input id="cr-file" type="file" accept=".pdf,.doc,.docx" hidden aria-label="' + esc(c.fFile) + '"></div></div>' +
    '<div class="form-msg" id="cr-msg" role="status" aria-live="polite"></div>' +
    '<div class="field full"><button class="btn btn-gold" type="submit" style="width:100%"><span>' +
      esc(c.send) + "</span></button></div>";
  var file = null;
  $("#cr-pick").addEventListener("click", function () { $("#cr-file").click(); });
  $("#cr-file").addEventListener("change", function (e) {
    file = e.target.files[0] || null;
    if (file && file.size > 8 * 1024 * 1024) { $("#cr-msg").textContent = c.errFile; file = null; return; }
    $("#cr-fname").textContent = file ? c.fFileChosen + " · " + file.name : c.fFileHint;
  });
  f.addEventListener("submit", function (e) {
    if (nativeGuard(e, f, "#cr-msg", c.errName)) return;
    e.preventDefault();
    var msg = $("#cr-msg");
    if (f.company.value) { msg.textContent = c.okTitle + " " + c.okBody; return; }
    var name = $("#cr-name").value.trim(), mail = $("#cr-email").value.trim();
    msg.style.color = "#D08A62";
    if (!name) { msg.textContent = c.errName; return; }
    if (!okMail.test(mail)) { msg.textContent = c.errEmail; return; }
    if (!file) { msg.textContent = c.errResume; return; }
    msg.style.color = "var(--gold)"; msg.textContent = c.sending;
    fileToB64(file).then(function (d) {
      return post("/careers", {
        name: name, email: mail, phone: $("#cr-phone").value, role: $("#cr-role").value,
        links: $("#cr-links").value, note: $("#cr-note").value, lang: lang,
        attachment: { filename: file.name, data: d }
      });
    }).then(function () {
      msg.textContent = c.okTitle + " " + c.okBody; f.reset(); file = null;
      $("#cr-fname").textContent = c.fFileHint;
    }).catch(function () { msg.textContent = c.okTitle + " " + c.okBody + " (" + EMAIL + ")"; });
  });
}

/* ───────────────────────── contact form ───────────────────────── */
function renderContactForm() {
  var f = $("#ctf-form"); if (!f) return;
  var c = t().contact;
  txt("ctf-t", c.formT);
  f.innerHTML =
    '<input class="hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">' +
    fld("ctf-name", "text", c.fName, "name", true) +
    fld("ctf-email", "email", c.fEmail, "email", true) +
    fld("ctf-phone", "tel", c.fPhone, "tel") +
    sel("ctf-topic", c.fTopic, c.fTopicOpts, false) +
    area("ctf-msg-in", c.fMsg, "") +
    '<div class="form-msg" id="ctf-msg" role="status" aria-live="polite"></div>' +
    '<div class="field full"><button class="btn btn-gold" type="submit" style="width:100%"><span>' +
      esc(c.send) + "</span></button></div>";
  f.addEventListener("submit", function (e) {
    if (nativeGuard(e, f, "#ctf-msg", c.err)) return;
    e.preventDefault();
    var msg = $("#ctf-msg");
    if (f.company.value) { msg.textContent = c.ok; return; }
    var name = $("#ctf-name").value.trim(), mail = $("#ctf-email").value.trim();
    if (!name || !okMail.test(mail)) { msg.style.color = "#D08A62"; msg.textContent = c.err; return; }
    msg.style.color = "var(--gold)"; msg.textContent = c.sending;
    post("/inquiry", {
      name: name, email: mail, phone: $("#ctf-phone").value,
      piece: $("#ctf-topic").value, details: $("#ctf-msg-in").value,
      lang: lang, page: location.href
    }).then(function () { msg.textContent = c.ok; f.reset(); })
      .catch(function () { msg.textContent = c.ok + " (" + EMAIL + ")"; });
  });
}

/* field builders */
function fname(label, ac) {
  /* Shopify recognises these three by name; the rest arrive as their
     own labelled lines. */
  if (ac === "email") return "contact[email]";
  if (ac === "name") return "contact[name]";
  if (ac === "tel") return "contact[phone]";
  return "contact[" + String(label).replace(/[\[\]]/g, "") + "]";
}
function fld(id, type, label, ac, req, hint, full) {
  return '<div class="field' + (full ? " full" : "") + '"><input id="' + id + '" type="' + type +
    '" name="' + esc(fname(label, ac)) + '" placeholder=" "' +
    (ac ? ' autocomplete="' + ac + '"' : "") + (req ? " required" : "") +
    '><label for="' + id + '">' + esc(label) + "</label>" +
    (hint ? '<span class="hint">' + esc(hint) + "</span>" : "") + "</div>";
}
function sel(id, label, opts, req) {
  return '<div class="field"><select id="' + id + '" name="' + esc(fname(label)) + '"' +
    (req ? " required" : "") +
    '><option value="" disabled selected></option>' +
    opts.map(function (o) { return "<option>" + esc(o) + "</option>"; }).join("") +
    '</select><label for="' + id + '">' + esc(label) + "</label></div>";
}
function area(id, label, hint) {
  /* The long one is the message body as far as Shopify is concerned. */
  return '<div class="field full"><textarea id="' + id + '" name="contact[body]" placeholder=" "></textarea>' +
    '<label for="' + id + '">' + esc(label) + "</label>" +
    (hint ? '<span class="hint">' + esc(hint) + "</span>" : "") + "</div>";
}
document.addEventListener("change", function (e) {
  if (e.target.tagName === "SELECT") e.target.classList.toggle("has", !!e.target.value);
});

/* ══════════════════════════════════════════════════════════════════
   FORMS, ON SHOPIFY

   A store already has somewhere for a message to go. Posting to it
   directly means the enquiry forms work the hour the theme is
   published — no Worker, no mail service, no API key, no CORS, and
   nothing to keep running. The script stops handling the submit and
   lets the browser do what browsers have always done.

   This is what Liquid's {% form 'contact' %} generates; written out by
   hand so the markup stays one set of files for both targets.
   ══════════════════════════════════════════════════════════════════ */
function shopifyForms() {
  if (CFG.forms !== "shopify") return false;
  $$("form.form").forEach(function (f) {
    if (f.dataset.native) return;
    f.dataset.native = "1";
    f.method = "post";
    f.action = "/contact#contact_form";
    f.setAttribute("accept-charset", "UTF-8");
    var hid = '<input type="hidden" name="form_type" value="contact">' +
              '<input type="hidden" name="utf8" value="✓">';
    var kind = { "cm-form": "Made-to-order enquiry", "cr-form": "Careers application", "ctf-form": "Contact" }[f.id] || "Website";
    hid += '<input type="hidden" name="contact[Form]" value="' + kind + '">';
    f.insertAdjacentHTML("afterbegin", hid);
    /* A plain post carries no file, so the one field that cannot
       survive the crossing is replaced with somewhere to put a link. */
    var pick = $(".filepick", f);
    if (pick) {
      var lbl = ($("button", pick) || {}).textContent || "";
      pick.parentNode.innerHTML =
        '<div class="field full"><input type="url" id="' + f.id + '-link" ' +
        'name="contact[File link]" placeholder=" "><label for="' + f.id + '-link">' +
        esc(lbl.replace(/…$/, "")) + "</label>" +
        '<span class="hint">' + esc(t().forms && t().forms.linkHint ||
          "Paste a link — Drive, Dropbox, iCloud") + "</span></div>";
    }
  });
  return true;
}

/* Shopify sends the visitor back to the page it came from with a flag
   on the address. That is the only moment there is to say thank you. */
function shopifyPosted() {
  if (CFG.forms !== "shopify") return;
  if (!/[?&]contact_posted=true/.test(location.search)) return;
  var m = $("#cm-msg") || $("#ct-msg") || $("#cr-msg");
  if (m) {
    m.style.color = "var(--gold)";
    m.textContent = (t().forms && t().forms.posted) ||
      "Thank you — your message is with the house. We answer every one within 24 hours.";
    m.scrollIntoView({ block: "center", behavior: "smooth" });
  }
}


/* ══════════════════════════════════════════════════════════════════
   LUCÍA, WITHOUT A BACKEND

   She used to need a Worker to say anything, and with no Worker she
   was taken off the door entirely. That is the wrong trade for a
   house: the questions people actually ask — is it a real diamond,
   what does IGI certify, what does a setting cost, do you have pink —
   are all already answered on this site, in both languages, in the
   house's own words.

   So she answers from those. No key, no request, no latency, and —
   the part that matters for a diamond house — no possibility of
   inventing a price or a grade, because every word she says was
   written for a page. When a Worker IS configured she steps aside and
   the full concierge takes over.

   The matching is deliberately plain: shared terms, weighted so that
   a rare word like "fluorescence" counts for far more than "the".
   ══════════════════════════════════════════════════════════════════ */
var Lucia = (function () {
  function norm(s) {
    return String(s || "").toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9ñ ]+/g, " ").replace(/\s+/g, " ").trim();
  }
  var STOP = (" the a an and or of to in on for is are be do does did you your my our " +
    "it this that with what how why when which can could would i me we us " +
    "el la los las un una y o de del al en por para que es son como cual cuales " +
    "su sus mi mis con lo se te me puedo puede hacer tiene tienen hay").split(" ");
  function terms(s) {
    return norm(s).split(" ").filter(function (w) {
      return w.length > 2 && STOP.indexOf(w) < 0;
    });
  }

  /* Everything the house has already said, as one searchable shelf. */
  function shelf() {
    var out = [], T = t();
    (((T.faq || {}).items) || []).forEach(function (it) {
      out.push({ q: it[0], a: it[1], w: terms(it[0] + " " + it[1]), qw: terms(it[0]) });
    });
    /* The cuts and the colours answer "do you have …" by name. */
    var cutNames = (CUTS || []).map(function (c) { return c[lang] || c.en; });
    out.push({
      q: lang === "es" ? "¿Qué tallas tienen?" : "Which cuts do you carry?",
      a: (lang === "es"
          ? "Treinta y nueve tallas, todas en El Libro: "
          : "Thirty-nine cuts, all of them in The Book: ") +
         cutNames.slice(0, 12).join(", ") + "… " +
         (lang === "es"
          ? "Puede filtrarlas por color y por forma."
          : "You can filter them by colour and by shape."),
      w: terms(cutNames.join(" ") + " cut cuts shape shapes talla tallas forma formas book libro"),
      qw: terms("cuts shapes carry have stock cut shape tallas formas tienen tiene")
    });
    var colNames = (COLORS || []).map(function (c) { return c[lang] || c.en; });
    out.push({
      q: lang === "es" ? "¿Qué colores hay?" : "Which colours are there?",
      a: (lang === "es" ? "Nueve colores: " : "Nine colours: ") + colNames.join(", ") + ". " +
         (lang === "es"
          ? "Elija uno en El Libro y las treinta y nueve tallas cambian con él."
          : "Choose one in The Book and all thirty-nine cuts change with it."),
      w: terms(colNames.join(" ") + " colour colours color colores colored coloured fancy pink pinks yellow blue green " +
        "rosa rosas rosado rosados amarillo amarillos azul azules verde verdes " +
        "champagne champan naranja morado gris blanco"),
      qw: terms("colour colours color colores colored coloured fancy have carry tienen hay " +
            "pink rosa rosado rosados yellow amarillo blue azul green verde")
    });
    out.push({
      q: lang === "es" ? "¿Cuánto cuesta una montura?" : "What does a mounting cost?",
      a: lang === "es"
         ? "El configurador de Hecho a Medida da el precio real de la montura al instante, de la misma tabla que usamos en vivo. La piedra se cotiza aparte."
         : "The configurator on Made to Order gives you the real setting price instantly, from the same chart we quote from live. The stone is priced separately.",
      w: terms("price cost how much setting mounting ring precio cuesta costo montura anillo configurador quote"),
      qw: terms("price cost much setting mounting precio cuesta costo montura")
    });
    return out;
  }

  function best(q) {
    var qt = terms(q); if (!qt.length) return null;
    var rows = shelf();
    /* A word that appears in one answer is worth far more than one that
       appears in all of them. */
    var df = {};
    rows.forEach(function (r) {
      var seen = {};
      r.w.forEach(function (w) { if (!seen[w]) { seen[w] = 1; df[w] = (df[w] || 0) + 1; } });
    });
    var scored = rows.map(function (r) {
      var s = 0, bag = {};
      r.w.forEach(function (w) { bag[w] = 1; });
      var qbag = {};
      (r.qw || []).forEach(function (w) { qbag[w] = 1; });
      qt.forEach(function (w) {
        if (qbag[w]) s += 1.9 * Math.log(1 + rows.length / (df[w] || 1));
        else if (bag[w]) s += Math.log(1 + rows.length / (df[w] || 1));
        else {
          /* a generous near-match, so "certificate" finds "certified" */
          for (var k in bag) {
            if (k.length > 3 && (k.indexOf(w) === 0 || w.indexOf(k) === 0)) { s += 0.5; break; }
          }
        }
      });
      return { r: r, s: s / Math.sqrt(qt.length) };
    }).sort(function (a, b) { return b.s - a.s; });
    return scored[0] && scored[0].s > 0.72 ? scored[0].r : null;
  }

  return {
    /* Returns the answer, or null when she genuinely does not know —
       at which point she says so rather than guessing. */
    answer: function (q) { var hit = best(q); return hit ? hit.a : null; }
  };
})();

/* ══════════════════════════════════════════════════════════════════
   LUCÍA — the concierge
   She answers from the Worker, which holds the key. With no Worker
   she still opens, still greets, and still points at the inbox.
   ══════════════════════════════════════════════════════════════════ */
function bot() {
  var open = $("#bot-open"); if (!open) return;
  var panel = $("#bot"), scrim = $("#bot-scrim"), log = $("#bot-log"),
      input = $("#bot-input"), send = $("#bot-send");
  var turns = [], busy = false, started = false;
  var b = function () { return t().bot; };

  var face = markSvg('width="34" height="34" style="color:var(--gold)"', { r: 168, w: 3.4, hair: .4 });
  $("svg", open).outerHTML = markSvg('width="26" height="26" style="color:var(--gold)"', { r: 168, w: 4, hair: 0 });
  $(".bot-top svg").outerHTML = face;

  function paintShell() {
    $("#bo-b").textContent = b().title;
    $("#bo-s").textContent = b().role;
    $("#bot-top-b").textContent = b().title;
    $("#bot-top-s").textContent = b().role;
    input.setAttribute("placeholder", b().ph);
    set("bot-chips", b().chips.map(function (c) {
      return "<button>" + esc(c) + "</button>";
    }).join(""));
  }
  function add(role, text) {
    var d = document.createElement("div");
    d.className = "msg " + (role === "user" ? "u" : role === "typing" ? "a t" : "a");
    d.textContent = text;
    log.appendChild(d); log.scrollTop = log.scrollHeight;
    return d;
  }
  function openBot() {
    panel.classList.add("on"); scrim.classList.add("on");
    if (!started) { started = true; add("assistant", b().hello); }
    setTimeout(function () { input.focus(); }, 320);
  }
  function closeBot() { panel.classList.remove("on"); scrim.classList.remove("on"); }
  open.addEventListener("click", openBot);
  scrim.addEventListener("click", closeBot);
  $("#bot-close").addEventListener("click", closeBot);
  addEventListener("keydown", function (e) { if (e.key === "Escape") closeBot(); });

  $("#bot-chips").addEventListener("click", function (e) {
    var btn = e.target.closest("button"); if (!btn) return;
    input.value = btn.textContent; ask();
  });
  send.addEventListener("click", ask);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); ask(); }
  });

  function ask() {
    var q = input.value.trim(); if (!q || busy) return;
    input.value = ""; busy = true; send.disabled = true;
    add("user", q); turns.push({ role: "user", content: q });
    /* With no Worker she answers from the pages themselves, which is
       instant and cannot invent anything. */
    if (!API) {
      var local = Lucia.answer(q);
      setTimeout(function () {
        if (local) { add("assistant", local); turns.push({ role: "assistant", content: local }); }
        else { add("assistant", b().offerForm || b().noReach); offerForm(); }
        busy = false; send.disabled = false;
      }, 260);
      return;
    }
    var typing = add("typing", b().connecting);
    post("/concierge", { messages: turns.slice(-16), lang: lang }).then(function (r) {
      typing.remove();
      if (!r || r.ok === false) { add("assistant", pick(r && r.error)); busy = false; send.disabled = false; return; }
      var text = r.text || "";
      if (text) { add("assistant", text); turns.push({ role: "assistant", content: text }); }
      (r.actions || []).forEach(function (a) {
        if (a.type === "lead_captured") add("assistant", b().leadOk);
        if (a.type === "open_commission_form") {
          var cta = document.createElement("button");
          cta.className = "btn btn-ghost"; cta.style.width = "100%";
          cta.innerHTML = "<span>" + esc(b().openForm) + "</span>";
          cta.onclick = function () { closeBot(); location.href = P("custom") + "#commission"; };
          log.appendChild(cta); log.scrollTop = log.scrollHeight;
        }
      });
      busy = false; send.disabled = false;
    }).catch(function () {
      typing.remove(); add("assistant", b().noReach); busy = false; send.disabled = false;
    });
  }
  function offerForm() {
    var cta = document.createElement("button");
    cta.className = "btn btn-ghost"; cta.style.width = "100%";
    cta.innerHTML = "<span>" + esc(b().openForm) + "</span>";
    cta.onclick = function () { closeBot(); location.href = P("custom") + "#commission"; };
    log.appendChild(cta); log.scrollTop = log.scrollHeight;
  }
  function pick(code) {
    var x = b();
    return code === "rate_limited" ? x.rateLimited
         : code === "not_configured" ? x.noReach
         : code === "bad_key" ? x.notGranted : x.generic;
  }
  window.__botPaint = paintShell;
  paintShell();
}

/* ══════════════════════════════════════════════════════════════════
   LEGAL
   ══════════════════════════════════════════════════════════════════ */
function renderLegal() {
  var root = $("#legal-root"); if (!root) return;
  var doc = document.body.getAttribute("data-doc") || "terms";
  var L = (window.LUX_LEGAL || {})[lang]; if (!L) return;
  var d = L[doc]; if (!d) return;
  document.title = d.title + " · Lucerna Miami";
  set("legal-nav", ["terms", "privacy", "shipping"].map(function (k) {
    return '<a href="' + PAGE(k) + (lang === "en" ? "?lang=en" : "") + '"' +
      (k === doc ? ' aria-current="page"' : "") + ">" + esc(L.nav[k]) + "</a>";
  }).join(""));
  root.innerHTML =
    "<h1>" + esc(d.title) + "</h1>" +
    '<p class="intro">' + esc(d.intro) + "</p>" +
    '<p class="note" style="margin-top:18px">' + esc(L.updated) + ": " + esc(L.date) + "</p>" +
    '<p class="notice">' + esc(L.notice) + "</p>" +
    d.body.map(function (s, i) {
      return '<section id="s' + i + '"><h2>' + esc(s[0]) + "</h2><p>" + esc(s[1]) + "</p></section>";
    }).join("");
  var back = $("#legal-back");
  if (back) { back.textContent = L.back; back.href = P("home"); }
}

/* ══════════════════════════════════════════════════════════════════
   BOOT
   ══════════════════════════════════════════════════════════════════ */
/* On a language switch the whole room is rewritten, and on a throttled
   phone writing it in one task costs 300-400ms before anything appears
   — over the 200ms an interaction is allowed. So the work is cut in two:
   what the visitor is looking at goes up in the same frame as the click,
   and the long tail (the thirty-nine tiles, the cabinet, the legal set,
   the scattered stones) waits for the frame after. The eye sees the
   first half; the second lands 30ms later, which is below notice. */
function renderNear() {
  renderNav(); renderPageHead(); renderHero(); renderTicker(); renderBadges();
  renderStone(); renderVocab(); renderRecord(); renderBespoke(); renderCommission();
  renderDoors(); renderJournal(); renderCareers(); renderContact(); renderContactForm();
  renderFooter();
}
function renderFar() {
  renderBook(); renderCert(); renderDays(); renderConfig();
  renderLive(); renderVault(); renderEthics(); renderFaq(); renderCabinet();
  renderFilm(); renderLegal();
  shopifyForms(); shopifyPosted(); scatter();
  if (window.__botPaint) window.__botPaint();
  watch();
}
function renderAll(deferHeavy) {
  document.documentElement.lang = lang;
  renderNear();
  if (!deferHeavy) { renderFar(); return; }
  requestAnimationFrame(function () { requestAnimationFrame(renderFar); });
}

$$("#lang button").forEach(function (btn) {
  btn.addEventListener("click", function () {
    lang = btn.getAttribute("data-lang");
    try { localStorage.setItem("lux-lang", lang); } catch (e) {}
    $$("#lang button").forEach(function (x) { x.setAttribute("aria-pressed", String(x === btn)); });
    renderAll(true);
    /* headings already on screen must re-run their rise */
    $$(".rev.r-in").forEach(function (card) {
      if (!$(".sp", card)) return;
      card.classList.remove("r-in");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { card.classList.add("r-in"); });
      });
    });
    var url = new URL(location.href);
    if (lang === "en") url.searchParams.set("lang", "en"); else url.searchParams.delete("lang");
    history.replaceState(null, "", url);
  });
});
$$("#lang button").forEach(function (x) {
  x.setAttribute("aria-pressed", String(x.getAttribute("data-lang") === lang));
});

mountTints();
setSel("white");
veil(); cursor(); dust(); chrome(); bot();
renderAll();

/* One request, once, and only where a price is shown. The page is
   already up by the time it lands; if the chart has changed, the
   configurator is redrawn with the new numbers. */
if (API && $("#cfg-h")) {
  fetch(API.replace(/\/+$/, "") + "/prices")
    .then(function (r) { return r.json(); })
    .then(function (r) {
      if (r && r.ok && adoptPrices(r.prices)) {
        if (r.pieces && r.pieces.length) PIECES = window.LUX_PIECES = r.pieces;
        renderConfig();
      }
    })
    .catch(function () {});
}

})();
